export enum NavigationType {
    BLOCK_MENU_CONTENT = 'block-menu-content',
    BLOCK_MENU_BURGER_CONTENT = 'block-burger-content-menu',
    BLOCK_FOOTER_MENU_1 = 'block-footer-menu-1',
    BLOCK_FOOTER_MENU_2 = 'block-footer-menu-2',
    BLOCK_FOOTER_MENU_3 = 'block-footer-menu-3',
}
